
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import Select from "react-select";
import { Table, Form, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import "./AdmAddIncome.css";
import { ApiUrl } from "../../../ApiUrl";

const AdmAttendanceEntry = () => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [bankOptions, setBankOptions] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [partyId, setPartyId] = useState("");
  const [partyName, setPartyName] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const editDataLoaded = useRef(false);
  const [dataReady, setDataReady] = useState(false);

  const [partyDetails, setPartyDetails] = useState({
    party_id: "",
    party_name: "",
    party_type: "",
  });
  const [rows, setRows] = useState([
    {
      id: Date.now(),
      category: { value: "", label: "" },
      amount: "",
      remarks: "",
    },
  ]);
  const [incomeNo, setIncomeNo] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [partyReference, setPartyReference] = useState(""); //  Declare state

  const dateRef = useRef(null);

const handleClear = (isNew = true) => {
  setSelectedPayment(null);
  setSelectedBank(null);
  setSelectedAccount(null);
  setPartyReference("");
  setPartyDetails({
    party_id: "",
    party_name: "",
    party_type: "",
  });

  if (isNew) {
    setRows([{ id: Date.now(), category: "", amount: "", remarks: "" }]);
  }
};


  // Fetch the income categories when the component mounts
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const orgId = localStorage.getItem("orgId");
        const branchId = localStorage.getItem("branchId");

        if (!orgId || !branchId) return;

        const response = await fetch(
          `${ApiUrl.apiurl}EXPENSE/EXPENSE_INCOME/ListBasedOnCategory/?org_id=${orgId}&branch_id=${branchId}&flag=I`
        );

        const data = await response.json();

        if (data.message === "success") {
          const options = data.data.map((category) => ({
            value: String(category.expense_category_id), // ensure it's string
            label: category.expense_category,
          }));
          setCategoryOptions(options);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Fetch Income No. from the API
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}EXPENSE/INCOME/GetIncomeNo/`)
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "success") {
          setIncomeNo(data.income_no); // Set the fetched income_no
        }
      })
      .catch((error) => {
        console.error("Error fetching income number:", error);
      });
  }, []);

  // Set the current date in the 'yyyy-mm-dd' format when the component mounts
  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Get month (0-based)
    const day = String(today.getDate()).padStart(2, "0"); // Ensure two digits

    // Format the date to 'yyyy-mm-dd'
    const formattedDate = `${year}-${month}-${day}`;
    setCurrentDate(formattedDate); // Set the current date
  }, []);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}BANK/GetAllbankList/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((bank) => ({
            value: bank.id,
            label: bank.bankname,
          }));
          setBankOptions(options);
        }
      })
      .catch((error) => {
        console.error("Error fetching bank list:", error);
      });
  }, []);
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}PAYMENTMETHOD/GetAllpaymentmethodList/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((method) => ({
            value: method.id,
            label: method.paymentmethod,
          }));
          setPaymentOptions(options);
        }
      })
      .catch((error) => {
        console.error("Error fetching payment methods:", error);
      });
  }, []);

  const handlePaymentChange = (selectedOption) => {
    setSelectedPayment(selectedOption);

    // If payment method is "CASH", clear the selected bank
    if (selectedOption?.label === "CASH") {
      setSelectedBank(null);
    }
  };

  // Fetch Account Numbers based on selected Bank
  useEffect(() => {
    if (selectedBank) {
      fetch(
        `${ApiUrl.apiurl}Account_Details/GetAccountDetailsBasedOnBankId/${selectedBank.value}/`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data && data.data) {
            const options = data.data.map((account) => ({
              value: account.id,
              label: account.bank_account.toString(), // Convert to string to ensure compatibility
            }));
            setAccountOptions(options);
          }
        })
        .catch((error) => {
          console.error("Error fetching account details:", error);
        });
    } else {
      setAccountOptions([]); // Clear account list when no bank is selected
    }
  }, [selectedBank]);

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleSelectedParty = (selectedParty) => {
    console.log("Selected Party:", selectedParty);

    setPartyDetails({
      party_id: selectedParty.party_id || "",
      party_name: selectedParty.party_name || "",
      party_type: selectedParty.party_type || "",
      gst_no: selectedParty.gst_no || "",
      city: selectedParty.city || "",
      state: selectedParty.state || "",
      address: selectedParty.address || "",
      phone: selectedParty.phone || "",
      email_id: selectedParty.email_id || "",
    });

    handleCloseModal();
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Handle input change for each field in the table
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  // Handle removing a row
const handleRemoveRow = (index) => {
  setRows((prevRows) => prevRows.filter((_, i) => i !== index));
};

  // Handle adding a new row
const handleAddRow = () => {
  setRows((prevRows) => [
    ...prevRows,
    { id: Date.now(), category: "", amount: "", remarks: "" },
  ]);
};

useEffect(() => {
  if (
    paymentOptions.length > 0 &&
    bankOptions.length > 0 &&
    categoryOptions.length > 0
  ) {
    setDataReady(true);
  }
}, [paymentOptions, bankOptions, categoryOptions]);

useEffect(() => {
  if (!dataReady) return; // Wait until all dropdowns are loaded
  if (editDataLoaded.current) return; // Prevent double-run
  if (!location.state?.incomeData) return; // Only run in edit mode

  const incomeData = location.state.incomeData;

  setSelectedPayment(
    paymentOptions.find((opt) => opt.label === incomeData.payment_method) ||
      null
  );
  setSelectedBank(
    bankOptions.find((opt) => opt.value === incomeData.bank_id) || null
  );

  // Set account placeholder — will get label after bank options fetch
  if (incomeData.account_id) {
    setSelectedAccount({ value: incomeData.account_id, label: "" });
  }

  setPartyDetails({
    party_id: incomeData.party_id || "",
    party_name: incomeData.party_name || "",
    party_type: incomeData.party_type || "",
  });

  setCurrentDate(incomeData.income_date || "");
  setIncomeNo(incomeData.income_no || "");
  setPartyReference(incomeData.party_reference || "");

  if (Array.isArray(incomeData.IncomeDetailsdata)) {
    setRows(
      incomeData.IncomeDetailsdata.map((detail) => ({
        id: detail.income_detail_id || Date.now(),
        category:
          categoryOptions.find(
            (opt) => opt.value === String(detail.category_id)
          ) || null,
        amount: detail.amount || "",
        remarks: detail.remarks || "",
      }))
    );
  } else {
    setRows([{ id: Date.now(), category: null, amount: "", remarks: "" }]);
  }

  editDataLoaded.current = true;
}, [dataReady, location.state?.incomeData]);



  const handleSave = async () => {
    // Retrieve org_id, branch_id, and academic_year_id from local storage
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");
    const academicSessionId = localStorage.getItem("academicSessionId");

    // Retrieve userId from session storage
    const userId = sessionStorage.getItem("userId");

    // Check if required values exist in localStorage and sessionStorage
    if (!orgId || !branchId || !academicSessionId || !userId) {
      alert("Missing required data. Please check.");
      return;
    }

    if (!partyDetails.party_id) {
  alert("Please fill the select party field.");
  
  return;

}
if (!partyReference.trim()) {
  alert("Please fill the Party Reference field.");
  return;
}

    const incomeHeaderDetails = {
      created_by: userId,
      org_id: orgId,
      branch_id: branchId,
      academic_year_id: academicSessionId,
      payment_method: selectedPayment?.label || "",
      bank: selectedBank?.value || null,
      account: selectedAccount?.value || null,
      party_id: partyDetails.party_id || null,
      date: currentDate,
      income_no: incomeNo,
      party_reference: partyReference,
      total_amount: totalAmount,
    };

    const incomeDetails = rows.map((row) => ({
      category_id: row.category?.value, // Ensure category is correct (use ID from API)
      amount: parseFloat(row.amount),
      remarks: row.remarks,
    }));

    const payload = {
      IncomeHeaderDetails: incomeHeaderDetails,
      IncomeDetails: incomeDetails,
    };

    try {
      let apiUrl = `${ApiUrl.apiurl}EXPENSE/INCOME/IncomeCreate/`;
      let method = "POST";

      //  Check if it's an update request
      if (location.state?.incomeData?.income_id) {
        const incomeId = location.state.incomeData.income_id;
        apiUrl = `${ApiUrl.apiurl}EXPENSE/INCOME/IncomeUpdate/${incomeId}`;
        method = "PUT"; // Update requires PUT method
      }

      const response = await fetch(apiUrl, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.message === "success") {
        alert(
          location.state?.incomeData?.income_id
            ? "Income details updated successfully!"
            : "Income details saved successfully!"
        );

        // Clear all fields after successful save/update
        handleClear(!location.state?.incomeData?.income_id);
      } else {
        console.error("Failed to save/update income details:", data.message);
      }
    } catch (error) {
      console.error("Error saving/updating income details:", error);
    }
  };

  const totalAmount = rows.reduce(
    (sum, row) => sum + parseFloat(row.amount || 0),
    0
  );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                EDIT INCOME
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12  d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/Search-income")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* <div className="row mb-2 mt-3 mx-2 ">
                <div className="col-12 custom-section-box">
                  <span style={{ fontWeight: 700 }}>Income Header</span>
                </div>
              </div> */}

              <div className="row  mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="payment-method" className="form-label">
                          Payment Method
                        </label>

                        <Select
                          id="payment-method"
                          className="detail"
                          classNamePrefix="payment-select"
                          options={paymentOptions}
                          value={selectedPayment}
                          onChange={(selectedOption) => {
                            setSelectedPayment(selectedOption);

                            // If payment is not BANK, clear bank & account
                            if (selectedOption?.label !== "BANK") {
                              setSelectedBank(null);
                              setSelectedAccount(null);
                            }
                          }}
                          placeholder="Select payment method"
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="bank" className="form-label">
                          Bank
                        </label>

                        <Select
                          id="bank"
                          className="detail"
                          classNamePrefix="bank-select"
                          options={bankOptions}
                          value={selectedBank}
                          onChange={(selectedOption) => {
                            setSelectedBank(selectedOption);
                            setSelectedAccount(null); // Clear account when bank changes
                          }}
                          placeholder="Select bank"
                          isDisabled={selectedPayment?.label !== "BANK"} // Disabled when payment is not BANK
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="account-no" className="form-label">
                          Account No
                        </label>
                        <Select
                          id="account-no"
                          className="detail"
                          classNamePrefix="account-select"
                          options={accountOptions}
                          value={selectedAccount}
                          onChange={setSelectedAccount}
                          placeholder="Select Account No"
                          isDisabled={
                            selectedPayment?.label !== "BANK" || !selectedBank
                          } // Disabled when payment is not BANK or no bank is selected
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="select-party" className="form-label">
  Select Party <span style={{ color: "red" }}>*</span>
</label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="select-party"
                            className="form-control detail"
                            placeholder="Enter select-party"
                            value={partyDetails.party_name}
                            disabled
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                      </div>

                      <SelectSearchParty
                        show={showModal}
                        handleClose={handleCloseModal}
                        onSelect={handleSelectedParty}
                      />
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="date" className="form-label">
                          Date <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          id="date"
                          className="form-control detail"
                          ref={dateRef}
                          value={currentDate}
                          onChange={(e) => setCurrentDate(e.target.value)}
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="income-no" className="form-label">
                          Income No.
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="income-no"
                            className="form-control detail"
                            placeholder="Income no"
                            value={incomeNo} // Set the value from the fetched income_no
                            disabled // Disable the field so the user cannot edit it
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="total-amount" className="form-label">
                          Total Amount
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="total-amount"
                            className="form-control detail"
                            value={totalAmount.toFixed(2)} // Display the sum with 2 decimal places
                            disabled // Disable the input field
                            readOnly // Make the field read-only
                            placeholder="Total amount"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="party-reference" className="form-label">
                          Party Reference{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="party-reference"
                            className="form-control detail"
                            placeholder="Enter party reference"
                            value={partyReference} // Bind value to state
                            onChange={(e) => setPartyReference(e.target.value)} // Update state on change
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Income Detail Table */}
              <h3 style={{ color: "black" }}>Income Detail</h3>
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table  table-bordered">
                    <thead className="thead-dark">
                      <tr>
                        <th>Sr.No</th>
                        <th>
                          Income Category
                          <span style={{ color: "red" }}>*</span>
                        </th>
                        <th>
                          Amount
                          <span style={{ color: "red" }}>*</span>
                        </th>
                        <th>Remarks</th>
                        <th>Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={row.id}>
                          <td>{index + 1}</td>
                          <td>
                            <select
                              className="form-select detail"
                              value={row.category?.value || ""}
                              onChange={(e) => {
                                const selected = categoryOptions.find(
                                  (option) => option.value === e.target.value
                                );
                                handleInputChange(
                                  index,
                                  "category",
                                  selected || { value: "", label: "" }
                                );
                              }}
                            >
                              <option value="">Select Category</option>
                              {categoryOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              className="form-control detail no-arrows"
                              // className="form-control detail"
                              value={row.amount}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "amount",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td>
                            <Form.Control
                              type="text"
                              className="form-control detail no-arrows"
                              value={row.remarks}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "remarks",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            <Button
                              variant="danger"
                              onClick={() => handleRemoveRow(index)}
                              disabled={rows.length === 1}
                            >
                              Remove
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <Button
                variant="primary"
                onClick={handleAddRow}
                className="ms-auto d-block"
              >
                Add New Row
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
